import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      width: '48rem',
      padding: theme.spacing(3),
    },
    cardContent: {
      alignItems: 'start',
    },
    title: {
      marginBottom: theme.spacing(2),
    },
  }),
)
